<script setup lang="ts">
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { ref, onMounted } from "vue";
import MomentSelection, {
  MomentSelectionInstance,
} from "@/components/mobile/popup/MomentSelection.vue";
import { watch } from "vue";

const props = defineProps({
  show: Boolean,
  collectionId: Number,
});

const emit = defineEmits(["update:show", "selected"]);

// State
const momentSelectionRef = ref<MomentSelectionInstance | null>(null);
const selectedMoments = ref<Record<number, Moment>>({});

onMounted(() => {});
// Event Handler
const clickConfirm = async () => {
  // 1. 计算出新增chapter和删除chapter
  emit("selected", selectedMoments.value);
};

watch(
  () => props.show,
  (val) => {
    if (val) {
      // selectedMoments.value = {};
      momentSelectionRef.value?.reset();
    }
  }
);
</script>
<template>
  <VanPopup
    :show="show"
    position="bottom"
    class="h-[90%] grid grid-rows-[auto_1fr]"
    @update:show="$emit('update:show', $event)"
  >
    <threads-nav
      :show-left-logo="false"
      :show-back="true"
      :go-back="() => emit('update:show', false)"
    >
      <template #center>
        <span>{{ $t("Message.selectMoment") }}</span>
      </template>
      <template #right>
        <button
          class="btn btn-sm btn-primary rounded"
          :disabled="Object.keys(selectedMoments).length === 0"
          @click="clickConfirm"
        >
          {{ $t("Buttons.save") }}
        </button>
      </template>
    </threads-nav>
    <moment-selection
      v-model:selected-moments="selectedMoments"
      :collectionId="collectionId"
      ref="momentSelectionRef"
    />
  </VanPopup>
</template>
